import React, { Component } from "react";
import { languages } from "../../constants/languages";
import CreateIcon from "@material-ui/icons/Create";
import IconButton from "@material-ui/core/IconButton";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import moment from "moment-timezone";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormHelperText from "@material-ui/core/FormHelperText";
import { Link } from "react-router-dom";
import { TimePicker } from "@material-ui/pickers";

class RoundDateTimeContainer extends Component {
  state = {
    open: false,
    day: "0",
    time: "",
    minutesBeforeSubmit: "",
  };

  toggleDialog = (e) => {
    e.stopPropagation();
    if ((this.props.tournamentStatus || {}).closed) {
      this.props.toggleFinishedDialog();
    } else {
      this.setState({ open: !this.state.open });
    }
  };

  componentDidMount = () => {
    let roundTimes = this.props.tournament.roundTimes || {};
    if (roundTimes[this.props.roundNum - 1]) {
      let time = roundTimes[this.props.roundNum - 1]["time"] || "";
      let day = roundTimes[this.props.roundNum - 1]["day"] || "0";
      let minutesBeforeSubmit =
        roundTimes[this.props.roundNum - 1]["minutesBeforeSubmit"] || "";
      this.setState({
        time: time,
        day: day,
        minutesBeforeSubmit: minutesBeforeSubmit,
      });
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.toggleDialog(e);
    const db = window.firebase.firestore();

    const batch = db.batch();

    const tournamentRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);

    let roundTimes = this.props.tournament.roundTimes || {};
    if (roundTimes[this.props.roundNum - 1] === undefined) {
      roundTimes[this.props.roundNum - 1] = {};
    }
    let time = "";
    if (this.state.time) {
      time = moment(this.state.time, "HH:mm").format("HH:mm");
    }
    roundTimes[this.props.roundNum - 1]["time"] = time;
    roundTimes[this.props.roundNum - 1]["day"] = this.state.day;
    roundTimes[this.props.roundNum - 1]["minutesBeforeSubmit"] =
      this.state.minutesBeforeSubmit;
    // console.log(roundTimes);

    if (time) {
      const roundNotificationsRef = db.collection("roundNotifications");

      let dateString = moment
        .unix(
          this.state.day !== "0"
            ? (this.props.daysByKey[this.state.day] || {}).date ||
                this.props.tournament.date
            : this.props.tournament.date
        )
        .tz(this.props.tournament.timezone || "Europe/Amsterdam")
        .format("YYYY-MM-DD");

      let minutes = 0;
      if (this.props.tournament.nH !== undefined) {
        minutes = this.props.tournament.nH * 60;
      }
      if (this.props.tournament.nM !== undefined) {
        minutes += this.props.tournament.nM;
      }
      if (
        this.props.tournament.nH === undefined &&
        this.props.tournament.nM === undefined
      ) {
        minutes = 15;
      }

      batch.set(
        roundNotificationsRef.doc(
          this.props.tournament[".key"] + (this.props.roundNum - 1)
        ),
        {
          startTimeStamp: moment
            .tz(
              dateString + " " + time,
              "YYYY-MM-DD HH:mm",
              this.props.tournament.timezone || "Europe/Amsterdam"
            )
            .unix(),
          sendTimeStamp: moment
            .tz(
              dateString + " " + time,
              "YYYY-MM-DD HH:mm",
              this.props.tournament.timezone || "Europe/Amsterdam"
            )
            .subtract(minutes, "m")
            .unix(),
          st: time,
          et: "",
          tournamentId: this.props.tournament[".key"],
          sent: false,
          roundNum: this.props.roundNum - 1,
        }
      );
    }

    batch.update(tournamentRef, { roundTimes: roundTimes });
    batch.commit();
  };

  handleChange = (event) => {
    event.stopPropagation();
    let newState = {};
    newState[event.target.name] = event.target.value;
    this.setState(newState);
  };

  handleTimeChange = (value) => {
    let newState = {};
    newState["time"] = value ? value.format("HH:mm") : "";
    this.setState(newState);
  };

  render() {
    return (
      <div>
        <IconButton
          aria-label="Change"
          onClick={this.toggleDialog}
          style={{ height: 16, width: 16 }}
        >
          <CreateIcon
            style={{ height: 16, width: 16, position: "absolute", top: 2 }}
          />
        </IconButton>
        <Dialog
          open={this.state.open}
          onClose={this.toggleDialog}
          aria-labelledby="form-dialog-title"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <DialogTitle id="form-dialog-title">
            {languages.schedule.round + " " + this.props.roundNum}
          </DialogTitle>
          <DialogContent style={{ width: 350, maxWidth: "97%", paddingTop: 0 }}>
            {(this.props.days || []).length > 0 && (
              <FormControl
                fullWidth
                style={{ marginTop: 15, marginBottom: 10 }}
              >
                <InputLabel htmlFor="day">{languages.schedule.day}</InputLabel>
                <Select
                  value={this.state.day}
                  onChange={this.handleChange}
                  inputProps={{
                    name: "day",
                    id: "day",
                  }}
                >
                  <MenuItem value="0">
                    {moment
                      .unix(this.props.tournament.date)
                      .format(languages.createTournament.dateFormat)}
                  </MenuItem>
                  {this.props.days.map((day) => (
                    <MenuItem key={day.id} value={day.id}>
                      {moment
                        .unix(day.date)
                        .format(languages.createTournament.dateFormat)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
            {/* <TextField
              fullWidth
              margin="dense"
              label={languages.schedule.startTime}
              name="time"
              type="time"
              onChange={this.handleChange}
              onClick={(e) => {
                e.stopPropagation();
              }}
              value={this.state.time}
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                step: 60, // 1 min
              }}
              style={{ marginBottom: 17 }}
            /> */}

            <TimePicker
              fullWidth
              ampm={false}
              label={languages.schedule.startTime}
              value={this.state.time ? moment(this.state.time, "HH:mm") : null}
              onChange={this.handleTimeChange}
              cancelLabel={languages.general.cancel}
              style={{ marginBottom: 12 }}
              clearable
              clearLabel={languages.schedule.clear}
            />

            {this.state.time && (
              <FormControl
                fullWidth
                aria-describedby="weight-helper-text"
                style={{ width: "100%" }}
              >
                <InputLabel htmlFor="minutesBeforeSubmit">
                  {languages.results.allowSubmitAfter}
                </InputLabel>
                <Input
                  id="minutesBeforeSubmit"
                  type="number"
                  name="minutesBeforeSubmit"
                  // placeholder={
                  //   this.props.tournament.matchDuration !== undefined
                  //     ? this.props.tournament.matchDuration.toString()
                  //     : defaultMatchTimes.matchDuration.toString()
                  // }
                  value={this.state.minutesBeforeSubmit}
                  onChange={this.handleChange}
                  endAdornment={
                    <InputAdornment position="end">
                      {languages.schedule.minutes}
                    </InputAdornment>
                  }
                />
                <FormHelperText>
                  {languages.formatString(
                    languages.results.allowSubmitAfterText,
                    this.props.tournament.timezone || "Europe/Amsterdam"
                  ) + " "}
                  <Link to="/account">{languages.header.account}</Link>.
                </FormHelperText>
              </FormControl>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.toggleDialog} color="primary">
              {languages.general.cancel}
            </Button>
            <Button
              onClick={this.handleSubmit}
              variant="contained"
              color="primary"
              type="submit"
            >
              {languages.general.save}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default RoundDateTimeContainer;
